import { render, staticRenderFns } from "./AnnounceTypeWardCell.vue?vue&type=template&id=1b276f0c&scoped=true&functional=true"
import script from "./AnnounceTypeWardCell.vue?vue&type=script&lang=js"
export * from "./AnnounceTypeWardCell.vue?vue&type=script&lang=js"
import style0 from "./AnnounceTypeWardCell.vue?vue&type=style&index=0&id=1b276f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1b276f0c",
  null
  
)

export default component.exports